/**
 * jsPDF wird erst geholt, wenn wirklich ein PDF gebaut wird.
 *
 * Fest eingebunden lag die Bibliothek im Startbuendel und wurde von jedem
 * Geraet beim ersten Aufruf mitgeladen. Gedruckt wird aber selten, und der
 * Druck-Weg wartet ohnehin (Punkte laden, Vorschau bauen) - dort faellt das
 * Nachladen nicht auf.
 *
 * Als Typ bleibt `jsPDF` ueberall normal importierbar (`import type`); Typen
 * verschwinden beim Uebersetzen und ziehen nichts ins Buendel. Nur der
 * Bauplan selbst kommt von hier.
 */
let geladen: Promise<typeof import('jspdf')> | null = null;

export function ladeJsPdf(): Promise<typeof import('jspdf')> {
	if (!geladen) geladen = import('jspdf');
	return geladen;
}
